import { useContext } from 'react'
import { InfoArgs, InfoDialogContext } from 'components/InfoDialog'

export default function useInfoDialog() {
  const context = useContext(InfoDialogContext)
  return (args: InfoArgs): void => context.showInfo(args)
}
